import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { CopyButton, DeleteButton, EditLink } from "../_components/AdminRowActions";

const ReferralItem = ({
  referral: { _id, name, website, code, isActive, date },
  removeReferral,
  copyLinkReferral,
  count,
}) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{name}</td>
    <td className={cellClass}>{website}</td>
    <td className={cellClass}>{code}</td>
    <td className={cellClass}>
      <AdminBadge tone={isActive ? "success" : "neutral"}>{isActive ? "Active" : "Inactive"}</AdminBadge>
    </td>
    <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD HH:mm")}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <CopyButton label="Copy referral link" onClick={() => copyLinkReferral(_id)} />
        <EditLink to={`/admin/referrallist/edit/${_id}`} label="Edit referral" />
        <DeleteButton
          label="Delete referral"
          onClick={() => removeReferral(_id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default ReferralItem;
